import React from 'react'

import InfiniteScrollContent from '../InfiniteScroll/InfiniteScrollContent'
import InfiniteScroll, { InfiniteScrollProps as _InfiniteScrollProps } from '../InfiniteScroll'

import PullToRefresh, { PullToRefreshProps } from '../PullToRefresh'
import Empty, { EmptyProps } from '../Empty'

export type ScrollListProps = Partial<PullToRefreshProps> & {
  // 列表的额外样式
  style?: React.CSSProperties
  // 列表类名
  listClassName: string
  // 列表数据
  listData: Array<any>
  // 是否有滚动加载
  hasInfiniteScroll: boolean
  // 加载中
  isLoading: boolean
  // 空状态相关属性
  emptyProps: EmptyProps
  // 下拉刷新相关属性
  pullToRefreshProps: PullToRefreshProps
  // 无限滚动相关属性
  infiniteScrollProps: _InfiniteScrollProps
}

const ScrollList = (props: ScrollListProps) => {
  const {
    theme = 'dark',
    listClassName,
    style,
    listData = [],
    hasInfiniteScroll = true,
    isLoading = true,
    emptyProps,
    infiniteScrollProps,
    pullToRefreshProps,
  } = props
  const _listData = listData ?? []
  const pullToRefreshTheme = theme.search('dark') > -1 ? 'light' : 'dark'

  return <PullToRefresh
      theme={pullToRefreshTheme}
      {...pullToRefreshProps}>
    <div className={listClassName}
        style={style}>
      {
        _listData.length > 0 &&
        <>{props.children}</>
      }
      {
        isLoading === false && _listData.length === 0 && infiniteScrollProps?.hasMore === false &&
        <Empty theme={theme}
            {...emptyProps}></Empty>
      }
    </div>
    {
      hasInfiniteScroll ?
        _listData.length > 0
        &&
        <InfiniteScroll
            {...infiniteScrollProps}>
          <InfiniteScrollContent
              {...infiniteScrollProps}></InfiniteScrollContent>
        </InfiniteScroll>
      :
      null
    }
  </PullToRefresh>
}

export default ScrollList